import packageJson from '../package.json';

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  measurementId: process.env.REACT_APP_FIRE_BASE_MEASURMENT_ID
};

export const primaryColor = process.env.REACT_APP_BRAND_PRIMARY_COLOR;

export const versaoFrontend = packageJson.version;

export const linkNovaAtivacao = process.env.REACT_APP_LINK_NOVA_ATIVACAO;
export const linkSuporte = process.env.REACT_APP_LINK_SUPORTE;

export const portalName = process.env.REACT_APP_WL_PORTAL_NAME;

export const urlAPI = process.env.REACT_APP_API_URL;
export const urlAPIPgLoader = process.env.REACT_APP_PGLOADER_API_URL;

export const limitDadosRelatorio = process.env.REACT_APP_LIMIT_DADOS_RELATORIOS;

export const tempoInatividade = process.env.REACT_APP_LIMIT_TEMPO_INATIVIDADE;
export const tempoLimitAlert = process.env.REACT_APP_LIMIT_TEMPO_ALERT;

export const showPgReports = process.env.REACT_APP_SHOW_PG_REPORTS === 'true';
export const showPgReportsPapel2 = process.env.REACT_APP_SHOW_PG_REPORTS_PAPEL2 === 'true';

export const showCreateSemanticModel = process.env.REACT_APP_SHOW_CREATE_SEMANTIC_MODEL === 'true';

export const showChatIA = process.env.REACT_APP_SHOW_CHAT_IA === 'true';
export const showPainelFinanceiro = process.env.REACT_APP_SHOW_PAINEL_FINANCEIRO === 'true';
export const showRelatorioIqvia = process.env.REACT_APP_SHOW_RELATORIO_IQVIA === 'true';

export const onlyArquiteturaAws = process.env.REACT_APP_ONLY_ARQUITETURA_AWS === 'true';

export const redeWlName = process.env.REACT_APP_WL_REDE_NAME;


